import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import {
    showNotification,
    UPDATE,
    withDataProvider,
} from 'react-admin';
import { push } from 'react-router-redux';

class UndeleteButton extends Component {
    handleClick = () => {
        const {dataProvider, dispatch, record} = this.props;

        record.deleted_at = null;

        dataProvider(UPDATE, 'posts', {id: record.id, data: record})
            .then(() => {
                dispatch(showNotification('comments.post.undelete.success', 'info'));
                dispatch(push('/posts'));
            })
            .catch((e) => {
                dispatch(showNotification('comments.post.undelete.error.general', 'warning'))
            });
    }

    render() {
        return <Button size="small" color="secondary" variant="outlined" label="Undelete" onClick={this.handleClick}>Undelete</Button>;
    }
}

UndeleteButton.propTypes = {
    dataProvider: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    record: PropTypes.object,
};

export default withDataProvider(UndeleteButton)